import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { EnsoRing } from "@/components/karate";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/federations", label: "Federations" },
  { to: "/news", label: "News" },
  { to: "/events", label: "Events" },
  { to: "/contact", label: "Contact" },
];

export function Footer() {
  return (
    <footer className="relative mt-24 overflow-hidden border-t border-ukf-gold/30 bg-ukf-obsidian text-slate-300" data-testid="site-footer">
      <img src="/branding/ukf-emblem.png" alt="" aria-hidden="true" className="pointer-events-none absolute -right-12 bottom-0 w-80 opacity-[0.05]" />
      <EnsoRing className="pointer-events-none absolute -left-16 top-10 h-64 w-64 opacity-[0.06]" stroke="#C9A24B" strokeWidth={3} />
      <div className="absolute inset-x-0 top-0 flex h-1.5 w-full" aria-hidden="true">
        {["#FFFFFF", "#EAB308", "#F97316", "#16A34A", "#2563EB", "#7C3AED", "#78350F", "#111827", "#8B181B"].map((c) => (
          <span key={c} style={{ backgroundColor: c }} className="flex-1" />
        ))}
      </div>
      <div className="relative mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <div className="flex items-center gap-3">
            <img src="/branding/ukf-emblem.png" alt="UKF Emblem" className="h-14 w-auto" />
            <div className="leading-[1.5]">
              <p className="font-serif text-base font-bold text-white">UNION OF KARATE</p>
              <p className="font-serif text-base font-bold text-white">FEDERATIONS</p>
            </div>
          </div>
          <div className="ukf-gold-rule mt-5" />
          <div className="mt-5 font-serif text-xl tracking-[0.3em] text-ukf-gold/50">空手道連盟連合</div>
        </div>

        <div>
          <h4 className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-ukf-gold">Navigation</h4>
          <ul className="grid grid-cols-2 gap-2.5">
            {NAV.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-${l.label.toLowerCase()}-link`}
                  className="text-sm text-slate-400 transition-colors hover:text-white"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-ukf-gold">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li>
              <a href="tel:9654712772" className="flex items-center gap-2 transition-colors hover:text-white" data-testid="footer-phone">
                <Phone className="h-4 w-4 text-ukf-gold" /> 9654712772
              </a>
            </li>
            <li>
              <a href="mailto:ukf.org.in@gmail.com" className="flex items-center gap-2 transition-colors hover:text-white" data-testid="footer-email">
                <Mail className="h-4 w-4 text-ukf-gold" /> ukf.org.in@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-white/10 py-5">
        <p className="text-center text-xs text-slate-500">
          © {new Date().getFullYear()} Union of Karate Federations. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
